import './_group-walls.scss';
import './_group-walls.dark-mode.scss';
import Wrapper from './Wrapper';
import Item from './Item';
import Icon from './Icon';

export default {
  Wrapper,
  Item,
  Icon,
};
